// src/api/users.ts
import api from './http';

export const getUsers = () => {
  return api.get('/usuarios');
};
